import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, ASSETS } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link is on the way.");
    } catch (err) {
      // Enumeration-safe — always show the same message.
      setSent(true);
      toast.success("If that email exists, a reset link is on the way.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative overflow-hidden bg-black" data-testid="forgot-password-page">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(239,43,43,0.15),transparent_55%)]" />
      <div className="w-full max-w-md relative">
        <Link to="/login" data-testid="forgot-back-login" className="font-mono text-[10px] tracking-[0.3em] text-white/50 hover:text-white transition-colors inline-flex items-center gap-2">← BACK TO SIGN IN</Link>
        <div className="mt-6 hairline rounded-2xl bg-white/[0.02] p-10">
          <img src={ASSETS.logo} alt="DJ SPY" className="h-12 w-auto" />
          <div className="mt-6">
            <div className="font-mono text-[10px] tracking-[0.3em] text-red-brand">// PASSWORD RESET</div>
            <div className="font-anton text-3xl text-white leading-none mt-2">Forgot password</div>
          </div>
          {sent ? (
            <div className="mt-8 space-y-4 text-white/70" data-testid="forgot-sent">
              <p>If <strong className="text-white">{email}</strong> matches an account, a reset link is on the way.</p>
              <p className="text-white/50 text-sm">Link expires in 60 minutes.</p>
              <Link to="/login" data-testid="forgot-return-login" className="btn-primary w-full justify-center">Back to sign in</Link>
            </div>
          ) : (
            <form className="mt-8 space-y-4" onSubmit={onSubmit} data-testid="forgot-form">
              <div>
                <label className="font-mono text-[10px] tracking-[0.3em] text-white/50">EMAIL</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@domain.com" dir="ltr" />
              </div>
              <button type="submit" disabled={loading} data-testid="forgot-submit" className="btn-primary w-full justify-center">
                {loading ? <Loader2 size={18} className="animate-spin" /> : null}
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}
          <div className="mt-6 text-center text-white/50 text-sm">
            Remembered it? <Link to="/login" className="text-red-brand hover:underline" data-testid="forgot-login-link">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
